export interface RevenueReconciliationReportEntity {

    reportTypeList: string[],
    printer: string,
    currency?: string | null,
    cashierId?: string | null,
    subType?: string | null,
    cutOffDateFrom?: Date | null,
    cutOffDateTo?: Date | null,
    cutOffDate2ndFrom?: Date | null,
    cutOffDate2ndTo?: Date | null,
    docDate?: Date | null,
    opsDateFrom?: Date | null,
    opsDateTo?: Date | null,

    [key: string]: string | boolean | Date | number | null | Object | undefined
}

export const EMPTY_REVENUE_RECONCILIATION_REPORT_ENTITY: RevenueReconciliationReportEntity = {
    reportTypeList: [],
    printer: "",
    currency: "",
    cutOffDateFrom: null,
    cutOffDateTo: null,
    cutOffDate2ndFrom: null,
    cutOffDate2ndTo: null,
    docDate: null,
    cashierId: null,
    opsDateFrom: null,
    opsDateTo: null,
    subType: null,
}
